'use strict';

Fancybox.defaults.Hash = false;
/**
 * Init Gallery Logic
 */
class TWER_GALLERY {

  /**
   * Сonstructor
   *
   * @param props
   */
  constructor(props) {
    Fancybox.bind('[data-fancybox]', {
      closeButton : 'outside',
      template : {
        closeButton : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.00146L22.9988 23.0008" stroke="white" stroke-linecap="round"/><path d="M23 1L1.00094 22.9991" stroke="white" stroke-linecap="round"/></svg>',
      },
      dragToClose : false,
      Image: {
        zoom: false,
        click: null,
        wheel : null
      },
      Toolbar: {
        items : {
          place : {
            type: 'div',
            class: "fancybox__place js-fancybox-twer-place",
            label: "Place",
            tabindex: -1,
            html: '',
            position: 'left'
          },
          prev: {
            type: "button",
            class: "fancybox__button--prev",
            label: "PREV",
            html: '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.82572 12.6514L1.00003 6.82569L6.82572 1" stroke="white"/></svg>',
            click: function (event) {
              event.preventDefault();

              this.fancybox.prev();
            },
            position: 'right'
          },
          next: {
            type: "button",
            class: "fancybox__button--next",
            label: "NEXT",
            html: '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.17428 12.6514L6.99997 6.82569L1.17428 1" stroke="white"/></svg>',
            click: function (event) {
              event.preventDefault();

              this.fancybox.next();
            },
            position: 'right'
          },
        },
        display: ['place', 'prev', 'next']
      },
      Carousel: {
        Navigation: false,
      },
      keyboard : {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: false,
        PageDown: false,
        ArrowUp: false,
        ArrowDown: false,
        ArrowRight: false,
        ArrowLeft: false,
      },
      on: {
        'Carousel.change': (fancybox) => {
          const $toolbar = fancybox.plugins.Toolbar.$container;

          const placeValue = fancybox.items[0].$trigger.dataset.place.trim();
          const $placeElement = $toolbar.getElementsByClassName('js-fancybox-twer-place')[0];

          const infoValue = fancybox.getSlide().caption;


          let separator = '';
          if(infoValue.length > 0) {
            separator = '<div class="place-separator"></div>'
          }

          $placeElement.innerHTML = `${placeValue}${separator}${infoValue}`;

        },
        'ready': (fancybox) => {
          const $toolbar = fancybox.plugins.Toolbar.$container;

          const placeValue = fancybox.items[0].$trigger.dataset.place.trim();
          const $placeElement = $toolbar.getElementsByClassName('js-fancybox-twer-place')[0];

          const infoValue = fancybox.items[0].$trigger.getElementsByTagName('img')[0].alt.trim();

          let separator = '';
          if(infoValue.length > 0) {
            separator = '<div class="place-separator"></div>'
          }
          $placeElement.innerHTML = `${placeValue}${separator}${infoValue}`;
        }
      },
      Thumbs: false,
      hash : false
    });
  }
}

export default TWER_GALLERY;
